import { cached } from '@glimmer/tracking';
import Model, { attr } from '@ember-data/model';

export type PropertyDiscountRulType =
  | 'BOOKED_BEYOND_AT_LEAST_X_DAYS'
  | 'BOOKED_WITHIN_AT_MOST_X_DAYS';

export default class PropertyDiscountRuleModel extends Model {
  @attr('string') ruleType!: PropertyDiscountRulType;
  @attr('negative-to-positive') priceChange!: number;
  @attr('string') priceChangeType!: string;
  @attr('number') thresholdOne!: number;

  @cached
  get isLastMinuteDiscountRule(): boolean {
    return this.ruleType === 'BOOKED_WITHIN_AT_MOST_X_DAYS';
  }

  @cached
  get isEarlyBirdDiscountRule(): boolean {
    return this.ruleType === 'BOOKED_BEYOND_AT_LEAST_X_DAYS';
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'property-discount-rule': PropertyDiscountRuleModel;
  }
}
